import { html, LitElement } from 'lit';
import { customElement } from 'lit/decorators.js';

@customElement('sdb-overlay-element')
class SdbOverlayElement extends LitElement {

    constructor() {
        super();
        this.container = null;
    }

    close() {
        this.container.removeChild(this);
    }

    render() {
        return html`
            <div
                @close-overlay=${() => { this.close(); }}>
                <slot></slot>
            </div>
        `;
    }

    firstUpdated() {
        let container = document.getElementById('app_overlay_container');
        if (!container) {
            container = document.createElement('div');
            container.id = 'app_overlay_container';
            container.className = 'app-theme-container';
            document.body.appendChild(container);
        }

        if (this.id) {
            const previouslyAttachedThis = container.querySelector(`#${this.id}`);
            if (previouslyAttachedThis) {
                container.removeChild(previouslyAttachedThis);
            }
        }

        this.container = container;
        this.container.appendChild(this);
    }
}

